import AnalyticsGroup from './AnalyticsGroup';

export default AnalyticsGroup;
